export const servicePaymentPeriodMessages = {
    'MLB 2025': 'al mes por 5 meses',
    'MLB 2025 Hospitality': 'al mes por 5 meses',
};
